module.exports = __webpack_public_path__ + "static/img/产品界面图_01@2x.9c6e96db.png";